var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "uploadImageModalRef",
      attrs: {
        id: "upload-image-modal",
        size: "lg",
        title: _vm.modalTitle,
        busy: _vm.busyButton
      },
      on: { ok: _vm.handleOk }
    },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-column", staticStyle: { gap: "1rem" } },
        [
          _c("b-form-file", {
            ref: "imageInputRef",
            attrs: {
              accept: _vm.accept,
              multiple: _vm.multiple,
              placeholder: _vm.placeholder,
              "drop-placeholder": _vm.dropPlaceholder,
              "browse-text": _vm.browseText
            },
            on: { change: _vm.onImagesSelected }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "images-list-container" },
            _vm._l(_vm.previewImages, function(image, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "image-wrapper",
                  class: { "image-wrapper-zoomed": _vm.zoomedIndex === index }
                },
                [
                  _c("img", {
                    staticClass: "preview-image",
                    class: { zoomed: _vm.zoomedIndex === index },
                    attrs: { src: image.base64Url, alt: "Preview da imagem" },
                    on: {
                      click: function($event) {
                        return _vm.toggleZoom(index)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.showDownloadButton
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm btn-success download-image-btn",
                          class: { hidden: _vm.zoomedIndex === index },
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.downloadImage(index)
                            }
                          }
                        },
                        [_c("b-icon-download")],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showRemoveButton
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-danger remove-image-btn",
                          class: { hidden: _vm.zoomedIndex === index },
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.removeImage(index)
                            }
                          }
                        },
                        [_c("b-icon-trash-fill")],
                        1
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }